var _rect, _rect2, _rect3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOurServiceHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 107,
    viewBox: "0 0 94 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 87.7034,
    width: 125,
    height: 6,
    rx: 3,
    transform: "rotate(-44.5577 0 87.7034)",
    fill: "#CEE5FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.54199,
    y: 87.723,
    width: 99.4878,
    height: 6,
    rx: 3,
    transform: "rotate(-44.5577 9.54199 87.723)",
    fill: "#FFE2EA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 101.803,
    width: 99.4878,
    height: 6,
    rx: 3,
    transform: "rotate(-44.5577 5 101.803)",
    fill: "#FFF3E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.9369 57.8784L43.2561 80.3414L20.5754 57.8784C19.0794 56.4227 17.9011 54.6729 17.1145 52.7394C16.328 50.8058 15.9503 48.7304 16.0052 46.6437C16.0602 44.557 16.5466 42.5043 17.4339 40.6149C18.3211 38.7254 19.59 37.0402 21.1606 35.6652C22.7311 34.2902 24.5694 33.2553 26.5596 32.6257C28.5497 31.996 30.6487 31.7853 32.7243 32.0067C34.8 32.2281 36.8073 32.8769 38.6198 33.9122C40.4324 34.9475 42.011 36.3469 43.2561 38.0222C44.5067 36.359 46.0871 34.9719 47.8984 33.9476C49.7098 32.9233 51.713 32.2838 53.7828 32.0693C55.8526 31.8549 57.9444 32.0699 59.9273 32.701C61.9102 33.3321 63.7414 34.3657 65.3065 35.7371C66.8715 37.1085 68.1367 38.7882 69.0227 40.671C69.9087 42.5538 70.3966 44.5993 70.4558 46.6793C70.515 48.7594 70.1442 50.8292 69.3666 52.7594C68.589 54.6895 67.4214 56.4384 65.9369 57.8966M43.2563 38.0039L33.2979 47.9622C32.731 48.5294 32.4125 49.2984 32.4125 50.1003C32.4125 50.9022 32.731 51.6712 33.2979 52.2383L34.94 53.8804C37.0266 55.967 40.4136 55.967 42.5002 53.8804L45.5243 50.8563C47.3289 49.0517 49.7765 48.0379 52.3285 48.0379C54.8806 48.0379 57.3282 49.0517 59.1328 50.8563L65.937 57.6605M44.768 66.7328L50.8162 72.781M52.3283 59.1726L58.3765 65.2208",
    stroke: "#5B9CD8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurServiceHeartIcon);
export default __webpack_public_path__ + "static/media/our-service-heart-icon.0449b432395d1f74f738c7747d484ccc.svg";
export { ForwardRef as ReactComponent };